<template>
	<div class="main-view privacy-container">
		<!-- eslint-disable -->
		<div class="bg-container privacy-hero" :style="{'background-image': 'url(' + require(`../assets/img/bgs/partners-hero.jpg`) + ')'}">
			<h1>Déclaration de Confidentialité d'Evergrow</h1>
			<bg-wave-element></bg-wave-element>
		</div>

		<div class="privacy-notice-copy template-inner">
			<h1>Date d'entrée en vigueur</h1>
			<p>La présente Déclaration de confidentialité entre en vigueur le 28 mai 2021. Il a été mis à jour pour la dernière fois le 28 mai 2021.</p>

			<h1>Déclaration sur la Confidentialité</h1>
			<p>Notre organisation prend grand soin de respecter la confidentialité des données personnelles et professionnelles contenues dans ses systèmes. C'est pourquoi nous ne collectons et ne traitons les données que pour les raisons et les moyens nécessaires pour vous fournir nos services. Vos données personnelles comprennent des informations telles que :</p>

			<ul>
				<li>Nom</li>
				<li>Adresse électronique</li>
				<li>Adresse postale</li>
				<li>Numéro de téléphone</li>
				<li>Autres données collectées qui pourraient vous identifier directement ou indirectement</li>
			</ul>

			<p>Notre Politique de confidentialité a pour but de vous décrire comment et quelles données nous collectons, et comment et pourquoi nous utilisons vos données personnelles. Elle décrit également les options que nous vous proposons pour accéder, mettre à jour ou prendre le contrôle de vos données personnelles que nous traitons.</p>

			<h1>Contact Confidentialité</h1>
			<p>Si vous avez des questions sur nos politiques ou processus décrits ci-dessous, vous pouvez contacter notre équipe chargée de la protection de la vie privée en envoyant un e-mail à <a href="mailto:privacy@carltonone.com" style="color: inherit; text-decoration: underline;">privacy@carltonone.com</a> ou <a href="mailto:privacy@globalrewardsolutions.com" style="color: inherit; text-decoration: underline;">privacy@globalrewardsolutions.com</a>. Ces boîtes de réception sont activement surveillées et quelqu'un vous contactera rapidement pour répondre à vos questions.</p>

			<h1>Collecte des données</h1>
			<p>Nous recueillons des informations afin de pouvoir offrir la meilleure expérience utilisateur possible sur notre ou nos plateformes. La plupart de ces informations sont collectées de la manière suivante :</p>

			<ul>
				<li>Formulaire de contact du site web - comme vous le faites lorsque vous demandez un rappel, un livre blanc ou une inscription à une newsletter</li>
				<li>Création ou modification d'un compte - par vous directement ou par une organisation qui vous a inscrit sur notre (nos) plateforme(s).</li>
				<li>Passation de commande - lors de la passation d'une commande dans notre système qui nécessite une adresse de livraison ou des coordonnées de contact.</li>
				<li>Demande du service clientèle - lorsque vous contactez notre équipe d'assistance pour résoudre un problème.</li>
			</ul>

			<p>Les informations recueillies sont structurées de manière à correspondre au strict minimum requis pour fournir des services adéquats à nos clients et utilisateurs. En outre, nous avons d'autres formes de collecte de données qui peuvent ne pas être visibles :</p>

			<h1>Cookies</h1>
			<p>Ils nous permettent de suivre le comportement de navigation sur nos plateformes. Nous utilisons Google Analytics pour nous donner un aperçu de l'utilisation du site et des performances globales du point de vue de l'utilisateur final. Aucune donnée personnelle n'est transmise à Google de cette manière et nous n'utilisons pas de suivi au-delà de notre (nos) plateforme(s) ; tous les cookies sont des cookies de première partie.<br>Nous utilisons également des cookies pour gérer l'authentification des utilisateurs sur nos plateformes. Ces cookies sont indispensables au bon fonctionnement de l'application.</p>

			<h1>Utilisation des services</h1>
			<p>Les journaux d'utilisation sont automatiquement générés par toutes les interactions avec nos services. Ces journaux contiennent l'utilisation spécifique du service, les adresses IP sources, les URL de référence du site, les performances du système, ainsi que des informations sur le navigateur, le système d'exploitation et l'appareil.</p>

			<h1>Données supplémentaires</h1>
			<p>Lors de l'inscription, votre compte peut avoir été configuré avec des détails supplémentaires concernant votre compte et votre rôle dans le programme concerné. Ces données sont généralement fournies par l'organisme d'affiliation et consistent généralement en un titre de poste et un département. Les informations fournies sont généralement pertinentes pour le type de programme que votre organisation exploite sur notre plateforme. Les demandes de renseignements concernant ce type de données doivent être transmises à votre propre organisation.</p>

			<h1>Utilisation des données</h1>
			<p>Bien que nous recueillions un minimum de données sur nos utilisateurs, nous traitons ces données uniquement dans le but de fournir des services contractuels à l'utilisateur final et au client. Les données sont uniquement utilisées à des fins :</p>
			<ol>
				<li>pour lesquelles nous avons reçu l'autorisation</li>
				<li>sont nécessaires pour fournir les services que vous achetez ou avec lesquels vous interagissez, ou</li>
				<li>pourraient être requises ou autorisées pour le respect de la loi ou à d'autres fins légitimes.</li>
			</ol>

			<p>Ces utilisations comprennent la fourniture, l'amélioration, la mise à jour et le perfectionnement des services que nous vous fournissons. Nous recueillons différents types d'informations relatives à votre utilisation et/ou à vos interactions avec nos services.</p>

			<p>Nous utilisons ces informations pour :</p>

			<ul>
				<li><strong>Améliorer et optimiser le fonctionnement et les performances de nos services </strong>,notamment nos applications et notre service clientèle.</li>
				<li><strong>Diagnostiquer les problèmes </strong>et identifier les risques de sécurité, les erreurs ou les améliorations nécessaires aux services.</li>
				<li><strong>Détecter et prévenir la fraude </strong>et les abus de nos services et systèmes.</li>
				<li><strong>Collecter des statistiques globales </strong>sur l'utilisation des services.</li>
				<li><strong>•	Comprendre et analyser la façon dont vous utilisez nos services </strong>et les fonctions et produits qui vous intéressent le plus.</li>
			</ul>

			<p>Souvent, une grande partie des données collectées sont des données agrégées ou statistiques sur la façon dont les individus utilisent nos services, et ne sont pas liées à des données personnelles, mais dans la mesure où elles sont elles-mêmes des données personnelles, ou sont liées ou peuvent être liées à des données personnelles, nous les traitons en conséquence.</p>

			<h1>Partage des données</h1>

			<p>Nous pouvons partager vos informations avec les entités suivantes afin de vous fournir un service :</p>

			<ol>
				<li><strong>Centre d'appels externalisé</strong> - nous pouvons faire appel à un centre d'appels externalisé avec du personnel spécialisé sous contrat pour fournir un service clientèle 24 heures sur 24 et 7 jours sur 7 à nos clients & utilisateurs.</li>
				<li><strong>Exécution produit </strong> - afin d'assurer l'exécution locale des commandes de récompenses, nous communiquerons vos coordonnées d'expédition à un fournisseur local qui vous livrera les marchandises.</li>
			</ol>

			<p>Dans tous les cas, nous nous assurons que nos partenaires de sous-traitance fournissent le même niveau de sécurité et de confidentialité à vos données personnelles que celui que nous fournissons.</p>

			<h1 class="underline">Droits sur les données</h1>

			<h1>Accès aux données</h1>

			<p>Vous êtes autorisé à demander un rapport sur les données personnelles contenues dans nos plateformes. Pour demander un rapport, vous pouvez effectuer l'une des démarches suivantes :</p>

			<ol>
				<li>Utiliser les outils fournis sur la plateforme (s'ils sont disponibles) et générer le rapport en fonction des besoins.</li>
				<li>Contacter l'administrateur de votre programme</li>
				<li>Contacter directement notre équipe du service clientèle et soumettre la demande par téléphone ou par e-mail (les coordonnées doivent être fournies dans votre programme).</li>
				<li>Contacter notre équipe de confidentialité à <a href="mailto:privacy@carltonone.com" style="color: inherit; text-decoration: underline;">privacy@carltonone.com</a> ou <a href="mailto:privacy@globalrewardsolutions.com" style="color: inherit; text-decoration: underline;">privacy@globalrewardsolutions.com</a></li>
			</ol>

			<h1>Édition des données</h1>
			<p>Vous êtes autorisé à mettre à jour les informations de votre profil d'utilisateur à tout moment en utilisant les outils fournis sur notre (nos) plateforme(s). Si vous n'êtes pas en mesure de le faire, veuillez contacter l'administrateur de votre programme local.</p>

			<h1>Suppression des données</h1>
			<p>Vous êtes autorisé à demander la suppression de vos informations personnelles de notre plateforme. Après cela, nous ne serons pas en mesure de vous fournir un service supplémentaire en tant que client. Cela aura les conséquences suivantes :</p>

			<ol>
				<li>
					Nous ne serons pas en mesure de vous fournir une assistance clientèle concernant les commandes passées :
					<ul>
						<li>a. Impossibilité de gérer les mises à jour de l'état des commandes et des livraisons.</li>
						<li>b. Impossibilité de traiter les retours de produits</li>
						<li>c. Impossibilité de fournir un quelconque remboursement</li>
						<li>d. Impossibilité de fournir une preuve d'achat sous garantie</li>
					</ul>
				</li>
				<li>Nous ne serons pas en mesure de vous fournir un historique de vos activités dans le système.</li>
				<li>Nous ne pourrons pas réactiver votre compte et/ou réémettre les soldes de comptes résiliés.</li>
			</ol>

			<p>De la même manière que pour les rapports sur les données personnelles, vous pouvez demander à ce que vos données personnelles soient retirées de notre (nos) plateforme(s) de l'une des manières suivantes :</p>

			<ol>
				<li>Utiliser les outils fournis sur la plateforme (si disponibles) et déclencher une demande de suppression.</li>
				<li>Contacter l'administrateur de votre programme</li>
				<li>Contacter directement notre équipe du service clientèle et soumettre la demande par téléphone ou par e-mail (les coordonnées doivent être fournies dans votre programme).</li>
				<li>Contacter notre équipe de confidentialité à <a href="mailto:privacy@carltonone.com" style="color: inherit; text-decoration: underline;">privacy@carltonone.com</a> ou <a href="mailto:privacy@globalrewardsolutions.com" style="color: inherit; text-decoration: underline;">privacy@globalrewardsolutions.com</a></li>
			</ol>

			<h1 class="underline">Traitement des données</h1>
			<h1>Sécurité des données</h1>
			<p>Nous suivons les normes généralement acceptées pour stocker et protéger les données personnelles que nous recueillons, tant pendant la transmission qu'une fois reçues et stockées, y compris l'utilisation du cryptage le cas échéant.</p>

			<h1>Stockage des données</h1>
			<p>Les données sont stockées en toute sécurité sur plusieurs sites, en collaboration avec nos partenaires technologiques.</p>
			<ul>
				<li>
					<strong>Installation de données primaires </strong>
					Partenaire technologique : Aptum Technologies
					Lieu : Toronto, Canada
					Services : Colocation

				</li>
				<li>
					<strong>Installation de reprise après sinistre </strong>
					Technology Partner: OVHcloud
					Lieu : Limburg, Germany
					Services : Cloud privé/DRaaS

				</li>
			</ul>

			<h1>Conservation des données</h1>
			<p>Nous ne conservons les données personnelles que le temps nécessaire à la fourniture des services et, par la suite, à diverses fins légitimes, juridiques ou commerciales. Il peut s'agir de périodes de conservation :</p>

			<ul>
				<li>Mandatées par la loi, un contrat ou des obligations similaires applicables à nos activités commerciales.</li>
				<li>Pour préserver, résoudre, défendre ou faire valoir nos droits légaux/contractuels.</li>
				<li>Nécessaires pour tenir des registres commerciaux et financiers adéquats et précis.</li>
			</ul>

			<p>Si vous avez des questions concernant la sécurité ou la conservation de vos données personnelles, vous pouvez nous contacter à l'adresse suivante : <a href="mailto:privacy@carltonone.com" style="color: inherit; text-decoration: underline;">privacy@carltonone.com</a> ou <a href="mailto:privacy@globalrewardsolutions.com" style="color: inherit; text-decoration: underline;">privacy@globalrewardsolutions.com</a>.</p>

			<h1>Transferts de données à l'étranger</h1>
			<p>Si vous utilisez nos Services depuis un pays autre que celui où se trouvent nos serveurs, vos communications avec nous peuvent entraîner le transfert de vos données personnelles au-delà des frontières internationales. De même, lorsque vous nous appelez ou que vous participez à une discussion en ligne, nous pouvons vous fournir une assistance depuis l'un de nos sites internationaux en dehors de votre pays d'origine. Dans ces cas, vos données personnelles sont traitées conformément à la présente Politique de confidentialité.</p>

			<h1>Conformité avec les demandes légales, réglementaires et d'application de la loi</h1>
			<p>Nous coopérons avec les autorités gouvernementales, les responsables de l'application des lois et les parties privées pour faire appliquer et respecter la loi. Nous divulguerons toute information vous concernant à des représentants du gouvernement, à des agents chargés de l'application de la loi ou à des parties privées si nous estimons, à notre seule discrétion, que cela est nécessaire ou approprié pour répondre à des réclamations et à des procédures légales (telles que des demandes d'assignation à comparaître), pour protéger notre propriété et nos droits ou la propriété et les droits d'un tiers, pour protéger la sécurité du public ou de toute personne, ou pour prévenir ou arrêter une activité que nous considérons comme illégale ou contraire à l'éthique.<br>
			Dans la mesure où nous sommes légalement autorisés à le faire, nous prendrons des mesures raisonnables pour vous informer dans le cas où nous serions tenus de fournir vos informations personnelles à des tiers dans le cadre d'une procédure judiciaire.</p>

			<h1>Notifications « Do Not Track » (ne pas suivre)</h1>
			<p>Certains navigateurs vous permettent d'informer automatiquement les sites Web que vous visitez de ne pas vous suivre à l'aide d'un signal « Do Not Track ». Il n'y a pas de consensus parmi les participants du secteur sur ce que signifie « Do Not Track » dans ce contexte. Comme de nombreux sites web et services en ligne, nous ne modifions pas actuellement nos pratiques lorsque nous recevons un signal « Do Not Track » du navigateur d'un visiteur. Pour en savoir plus sur la fonction « Do Not Track », vous pouvez consulter le site <a href="www.allaboutdnt.com" style="color: inherit; text-decoration: underline;">www.allaboutdnt.com</a>.</p>

			<h1>Restrictions d'âge</h1>
			<p>Nos services sont disponibles à l'achat uniquement pour les personnes âgées de plus de 16 ans. Nos services ne sont pas destinés à être utilisés par des personnes de moins de 16 ans ni conçus pour les séduire. Si vous savez ou avez des raisons de croire qu'une personne âgée de moins de 16 ans nous a fourni des données personnelles, veuillez nous contacter à l'adresse suivante : <a href="mailto:privacy@carltonone.com" style="color: inherit; text-decoration: underline;">privacy@carltonone.com</a> ou <a href="mailto:privacy@globalrewardsolutions.com" style="color: inherit; text-decoration: underline;">privacy@globalrewardsolutions.com</a>.</p>

			<h1>Modifications de la Politique de confidentialité</h1>
			<p>Nous nous réservons le droit de modifier cette Politique de confidentialité à tout moment. Si nous décidons de modifier notre Politique de confidentialité, nous publierons ces modifications dans la présente Politique de confidentialité et à tout autre endroit que nous jugerons approprié, afin que vous sachiez quelles informations nous recueillons, comment nous les utilisons et dans quelles circonstances, le cas échéant, nous les divulguons.</p>
			
			<p>La dernière mise à jour de cette Déclaration de Confidentialité date du 28 mai 2021.</p>

		</div>

		<Demo />
	</div>
</template>

<script>
	/* eslint-disable */

	import Demo from "../components/Demo";

	export default {
		components: {
			Demo
		}
	}
</script>

<style lang="stylus" scoped>
	.privacy-container 
		margin-top 117px

	.privacy-hero
		background center top / cover no-repeat #fff
		padding 100px 0 240px
		margin-bottom 40px
		position relative
		
		h1 
			color white
			font-size: 85px
			text-align center
			
	.privacy-notice-copy
		margin-bottom 100px
		
		h1
			font-size 30px
			margin-bottom 10px !important
			
		.underline 
			text-decoration underline
			font-size 34px
			
		ul,
		ol
			font-weight 300
			margin-top 0
			padding-bottom 20px
			
		a
			transition all 0.125s ease
			
			&:hover
				color #00A562
</style>